import SharedSlideshow from '@pixelunion/pxs-slideshow';
import * as breakpoint from '@pixelunion/breakpoint';

export default class Slideshow extends SharedSlideshow {
  viewportIsMobile() {
    return breakpoint.max('S');
  }
}
